import { render } from "./CommandeDetailsPage.vue?vue&type=template&id=6afd0c62&scoped=true"
import script from "./CommandeDetailsPage.vue?vue&type=script&lang=js"
export * from "./CommandeDetailsPage.vue?vue&type=script&lang=js"

import "./CommandeDetailsPage.vue?vue&type=style&index=0&id=6afd0c62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6afd0c62"]])

export default __exports__